import { setGlobal } from 'reactn'

export const openSnackBar = (newMessage: string, error?: boolean, duration?: number) => {
  setGlobal({
    snackBar: {
      isOpen: true,
      isError: error,
      message: newMessage,
      duration,
    },
  })
}
